var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-image",attrs:{"df":"","fjc":"","fic":""}},[_c('img',{class:{ profile: _vm.profileImage },attrs:{"src":_vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }